import type { Workspace } from "../lib/types";
import { request } from "./client";

export function listWorkspaces(signal?: AbortSignal): Promise<Workspace[]> {
  return request<Workspace[]>("/api/v1/workspaces", signal ? { signal } : {});
}

export function createWorkspace(name: string): Promise<Workspace> {
  return request<Workspace>("/api/v1/workspaces", {
    method: "POST",
    body: { name },
  });
}

/** ADR 0012 — rename a workspace (any member). */
export function renameWorkspace(id: string, name: string): Promise<Workspace> {
  return request<Workspace>(`/api/v1/workspaces/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: { name },
  });
}

/** ADR 0012 — delete a workspace and cascade its projects (owner-only). */
export function deleteWorkspace(id: string): Promise<void> {
  return request<void>(`/api/v1/workspaces/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}
